import { type PaymentFormData, type PurchasePrice } from "../types";
import { type ProcessPaymentRequest } from "../../types/requests";

interface RemapPaymentFormToRequestParams {
  formData: PaymentFormData;
  purchasePrice: PurchasePrice;
}

export const remapPaymentFormToRequest = ({
  formData,
  purchasePrice,
}: RemapPaymentFormToRequestParams): ProcessPaymentRequest => {
  const { creditCardInfo, billingInfo, packs } = formData;
  const { totalAmount, subtotalAmount, taxAmount, packsPrices } = purchasePrice;
  const packPriceById = new Map(packsPrices.map((p) => [p.packId, p]));

  return {
    amount: totalAmount,
    subtotalAmount,
    tax: taxAmount,
    packs: packs.map((pack) => {
      const matchingPrice = packPriceById.get(pack.packId);
      return {
        packId: pack.packId,
        licensesCount: pack.licensesCount ?? 0,
        subtotalAmount: matchingPrice?.subtotalAmount ?? 0,
        tax: matchingPrice?.taxAmount ?? 0,
        amount: matchingPrice?.totalAmount ?? 0,
      };
    }),
    cardData: {
      cardNumber: creditCardInfo.cardNumber,
      cardExpiration: `${creditCardInfo.expirationMonth}/${creditCardInfo.expirationYear}`,
      cardCode: creditCardInfo.securityCode,
      cardholderName: creditCardInfo.nameOnCard,
      cardProviderType: creditCardInfo.cardProviderType,
    },
    billingAddress: {
      address1: billingInfo.streetAddress,
      state: billingInfo.state,
      zipCode: billingInfo.zipCode,
      city: billingInfo.city,
      country: billingInfo.country,
    },
  };
};
